/*
 * @Author: git config zhang && 10899060+inheaven98@user.noreply.gitee.com
 * @Date: 2021-11-30 16:34:00
 * @LastEditors: ws2044 a3131854594@163.com
 * @LastEditTime: 2025-06-19 18:06:13
 * @FilePath: \yk_ai_editor\src\settings.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
module.exports = {
	title: 'LegalFlow管理平台',

	/**
	 * @type {boolean} true | false
	 * @description Whether show the settings right-panel
	 */
	showSettings: false,

	/**
	 * @type {boolean} true | false
	 * @description Whether need tagsView
	 */
	tagsView: false,

	/**
	 * @type {boolean} true | false
	 * @description Whether fix the header
	 */
	fixedHeader: true,

	/**
	 * @type {boolean} true | false
	 * @description Whether show the logo in sidebar
	 */
	sidebarLogo: true,

	/**
	 * @type {string | array} 'production' | ['production', 'development']
	 * @description Need show err logs component.
	 * The default is only used in the production env
	 * If you want to also use it in dev, you can pass ['production', 'development']
	 */
	errorLog: 'production'
}
